<template src="./manageRemindersModal.html"></template>

<script>
import dmModalMixin from '../../../../dmFramework/dmJS/dmModalMixin';
import dataTableMixin from '../../../js/dataTableMixin.js';
import surveysEndpoints from '../surveys.endpoints';

export default {
    name: 'manage-reminders-modal',
    mixins: [dmModalMixin, dataTableMixin],
    data() {
        return {
            dto: {},
            selectedRow: null,
            currentTime: null,
            scheduledRemindersTableColumns: [],
            scheduledRemindersTableItems: [],
            scheduledRemindersTableSortBy: {
                columns: [{ field: 'ReminderSendDateTime', direction: 'Ascending' }],
            },
            scheduledRemindersTableActions: [
                {
                    text: 'Edit',
                },
                {
                    text: 'Delete',
                },
            ],
        }
    },
    computed: {
        lastReminder() {
            if (this.dto.LastReminderDateF) {
                return 'Last reminders sent on ' + this.dto.LastReminderDateF; 
            }

            return 'No reminders have been sent'
        },
    },
    methods: {
        btnAddOnClick() {
            let modalData = {
                mode: 'add',
                dto: {
                    SurveyID: this.modalData.surveyID
                },
                callback: this.getScheduledReminders
            }
            
            DMUtils.openApplicationModal('remindersEditModal', modalData);            
        },
        btnCancelOnClick() {
            this.closeModal();
        },
        scheduledRemindersTableRowOnClick(args) {
            this.selectedRow = args;
        },
        scheduledRemindersTableActionOnClick(args) {
            surveysEndpoints.getScheduledReminderByID(this.selectedRow.rowData.SurveyScheduledReminderID)
                .then((response) => {
                    if (args.item.text === 'Edit') {
                        let modalData = {
                            mode: 'edit',
                            dto: response,
                            surveyID: this.modalData.surveyID,
                            callback: this.getScheduledReminders
                        }
                        
                        DMUtils.openApplicationModal('remindersEditModal', modalData);            
                    }
        
                    if (args.item.text === 'Delete') {
                        let confirmCallback = () => {
                            surveysEndpoints.deleteScheduledReminder(this.selectedRow.rowData.SurveyScheduledReminderID)
                                .then(() => {
                                    this.getScheduledReminders();
                                })
                        }

                        DMUtils.confirmShow('Are you sure you want to delete this reminder?', 'Confirm', confirmCallback, null)
                    }
                })
        },
        getScheduledReminders() {
            return surveysEndpoints.getScheduledReminders(this.modalData.surveyID)
                .then((response) => {
                    this.scheduledRemindersTableItems = response;
                });
        },
        hideOptionsForSentReminders(args) {
            console.log(args)
            if (args.data.ReminderHasBeenSent) {
                args.row.cells[0].children[0].style.visibility = 'hidden';
            }
        }
    },
    created() {
        this.dto = DMUtils.copy(this.modalData.dto);

        this.getScheduledReminders();

        surveysEndpoints.getTime()
            .then((response) => {
                this.currentTime = response.result;
            });

        this.scheduledRemindersTableColumns = [
            {
                type: 'iconTemplate',
                iconName: 'ellipsis',
                ellipsisActions: this.scheduledRemindersTableActions,
                iconOnClick: this.scheduledRemindersTableActionOnClick,
                width: '55px',
                allowSorting: false
            },
            {
                key: 'ReminderSendDateTime',
                label: 'Date/Time (EST)',
                type: 'Date',
                format: 'MM/dd/yyyy hh:mm a',
                allowSorting: true
            },
            {
                key: 'ReminderHasBeenSent',
                label: 'Status',
                allowSorting: true,
                formatter: (column, data) => {
                    return data.ReminderHasBeenSent ? 'Sent' : 'Scheduled';
                }
            },
            {
                key: 'NumberOfRespondentsF',
                label: '# of Respondents',
                allowSorting: true,
                textAlign: 'Right'
            }
        ]
    },
}
</script>